const onAfterRenderClient = (pageContext: any)=>{
    if (typeof window !== 'undefined') {
        if (window.gtag) {
            window.gtag('event', 'page_view', {
                page_path: window.location.pathname,
                page_title: document.title,
            });
        }

        // Tawk widget: hide on specific paths, show otherwise
        const hiddenPaths = ['/design-tool', '/cart/checkout'];
        const path = window.location.pathname;
        const shouldHide = hiddenPaths.some(p => path.startsWith(p));

        const applyTawkVisibility = () => {
            const api = (window as any).Tawk_API;
            if (api && typeof api.hideWidget === 'function' && typeof api.showWidget === 'function') {
                if (shouldHide) api.hideWidget();
                else api.showWidget();
            }
        };

        // Try immediately and a few times after to handle async load of Tawk script
        applyTawkVisibility();
        setTimeout(applyTawkVisibility, 0);
        setTimeout(applyTawkVisibility, 300);
        setTimeout(applyTawkVisibility, 1000);
    }
}

export {onAfterRenderClient}